// Watch builds `TrainingVideos/${item.File}`. A row with no File interpolates
// to `TrainingVideos/undefined`, and Storage rejects that object as not found.

export function trainingVideoStoragePath(item) {
    const file = item?.File;
    if (typeof file !== "string" || file.length === 0) return null;
    return `TrainingVideos/${file}`;
}
